import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

export const LogUrlChangesComponent = React.memo(() => {
  const location = useLocation();
  useEffect(() => {
    console.log('navigate', location.pathname, location.search, location.hash);
  }, [location.pathname]);
  return null;
});
